import Button from 'components/button';
import styles from './styles.module.scss';
import { Input } from 'components/input';
import { useState } from 'react';
import { Select } from 'components/select';
import { MarketTypes } from 'api/types';
import useAddFavoriteList from 'api/hooks/use-favorite-list-create';

interface ICreateFavoriteListForm {
  onClose: () => void;
  refetchFavoriteList: () => void;
}

const CreateFavoriteListForm = ({
  refetchFavoriteList,
  onClose,
}: ICreateFavoriteListForm) => {
  const [name, setName] = useState('');
  const [marketType, setMarketType] = useState<MarketTypes>(MarketTypes.SECONDARY);
  const handleChange = (value: string) => {
    setName(value);
  };

  const { trigger, isMutating } = useAddFavoriteList(name, marketType);

  const addFavoriteList = async () => {
    if (name && marketType) {
      await trigger();
      refetchFavoriteList();
      onClose();
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.select}>
        <Select
          label='Для Первички/Вторички'
          onSelect={(value: MarketTypes) => setMarketType(value)}
          selected={marketType}
          menuArray={[
            { key: MarketTypes.PRIMARY, label: 'Первичка' },
            { key: MarketTypes.SECONDARY, label: 'Вторичка' },
          ]}
          multiple={false}
        />
      </div>

      <div className={styles.input}>
        <Input
          label='Название списка'
          placeholder={'Название списка'}
          value={name}
          isMainPlaceholder
          onChange={handleChange}
        />
      </div>

      <div className={styles.flexButton}>
        <Button variant='gray' onClick={onClose} label='Отменить' />
        <Button
          loading={isMutating}
          onClick={() => {
            addFavoriteList();
          }}
          label='Создать'
        />
      </div>
    </div>
  );
};

export default CreateFavoriteListForm;
